import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

// Models
import { UserInfo } from '../../model/free-trial';

// Services
import { DataService } from '../../services/data.service';

@Component({
    selector: 'app-free-trial-verify',
    templateUrl: './free-trial-verify.component.html',
    styleUrls: ['./free-trial-verify.component.scss']
})
export class FreeTrialVerifyComponent implements OnInit {

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private dataSvc: DataService
    ) { }

    ngOnInit() {
        try {
            let email: string = this.route.snapshot.queryParamMap.get('email');

            // No email passed in, move to error page
            if (!email) {
                this.router.navigate(['error404']);
                return;
            }

            // Emails don't match, invalid validation
            if (!this.emailMatches(email)) {
                this.router.navigate(['error404']);
                return;
            }

            // Update user info with email verified set to true
            this.verifyAndQueueLeadCreation();
            this.router.navigate(['free-trial'])

        } catch (e) {
            console.log(e);
            this.router.navigate(['error404']);
        }
    }

    // Determine if the "email" URL Param matches the email in the current session
    private emailMatches(email: string): boolean {
        let currentSession: {userInfo: UserInfo} = this.dataSvc.getItemFromSessionStorage("currentSession");

        if (!currentSession.userInfo)
            return false;

        // Get the email from the browser session
        let sessionEmail: string = currentSession.userInfo.email || "";

        return sessionEmail === email;
    }

    // Update current session with the current user as verified.
    // AND set boolean that will cause free-trial to create the lead
    private verifyAndQueueLeadCreation() {
        let currentSession: {userInfo: UserInfo} = this.dataSvc.getItemFromSessionStorage("currentSession");

        // update session, 'newlyVerified' property will cause lead creation
        this.dataSvc.saveItemToSessionStorage('currentSession', {userInfo: currentSession.userInfo, newlyVerified: true})
    }
}
